
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 337.66 337.98"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M261.42 0c-51.58.54-104.44.07-150.53.19-16.49-.56-36.3-.48-51.68 12.26-16.93 13.85-18.6 36.24-18.15 54 .3 56.06 0 112.19.11 168.34a7 7 0 006.76 6.74h20.88a7 7 0 006.76-6.74c.18-60.89-.36-121.74.29-182.48.7-8.86 8.48-17.14 17.26-17.28 60.78-1.09 123.24-.57 177.83-.55-10 12.24-8.92 28.65-8.83 40.66-.62 74.79.27 150.73-.42 214.77a14.6 14.6 0 01-4.94 9.09c-2.68 2.21-5.31 3-8.35 1.9l-.32-.08c-6.09-1.81-10.64-5.92-14.43-11.67s-6.55-13.06-8.54-20c0-.2-.11-.4-.18-.61a10.88 10.88 0 00-6.61-5.91c-71.51-.71-146.23-.27-211.51-.27a6.74 6.74 0 00-6.74 7.35c2.48 28.46 21.3 54.83 49.12 66.24a27 27 0 009.38 2h199.6c19.91.2 40.48-25.57 38.24-48.83V75.84h34.53a6.59 6.59 0 006.76-6.95c-1.39-31.58-24.46-62.05-57-67.28h-.18a134 134 0 00-19-1.59z"}}),_c('path',{staticStyle:{"isolation":"isolate"},attrs:{"d":"M111.9 70.97h113.57a10.81 10.81 0 0110.81 10.81 10.81 10.81 0 01-10.81 10.82H111.9a10.81 10.81 0 01-10.81-10.82 10.81 10.81 0 0110.81-10.81zm0 48.37h113.57a10.81 10.81 0 0110.81 10.81 10.81 10.81 0 01-10.81 10.82H111.9a10.81 10.81 0 01-10.81-10.82 10.81 10.81 0 0110.81-10.81zm0 48.36h113.57a10.82 10.82 0 0110.81 10.82 10.81 10.81 0 01-10.81 10.81H111.9a10.81 10.81 0 01-10.81-10.81 10.82 10.82 0 0110.81-10.82zm0 48.37h113.57a10.81 10.81 0 0110.81 10.82 10.81 10.81 0 01-10.81 10.81H111.9a10.81 10.81 0 01-10.81-10.81 10.81 10.81 0 0110.81-10.82z","opacity":".99"}})])
          )
        }
      }
    